export default "__VITE_ASSET__fbKRguFs__"